// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'the-order',
  heroImg: 'hero.jpg',
  heroTheme: 'light',
  heroHeadingOne: 'THE ORDER: 1886',
  heroHeadingTwo: 'GAME MARKETING EXPERIENCE',
  details: [
    {
      title: 'Agency',
      items: ['Psycle', 'Google Zoo'],
    },
    {
      title: 'Brand',
      items: ['Sony PlayStation'],
    },
    {
      title: 'Platform',
      items: ['Web', 'Social Media', 'Sony e-commerce systems'],
    },
  ],
  heading: 'COMBINING EXCLUSIVE VIDEO WITH CONTEXTUAL CONTENT TO CREATE UNIQUE E-COMMERCE OPPORTUNITIES',
  challengeImg: 'challenge.jpg',
  challenge: [
    'To create a video-based marketing platform that emphasised the unique qualities of The Order: 1886 game universe while delivering higher conversion rates and providing new upselling opportunities.',
  ],
  solutionImg: 'solution.jpg',
  solution: [
    'Working with the Sony PlayStation US marketing team and Google Zoo, we used our own video CMS as a framework to create a unique storytelling experience based around a virtual pinboard interface.',
    'The experience allowed us to show off our extensive creative, copywriting and development skills through over thirty articles, custom Google Maps and Street View experiences - all based around exclusive game video content specially created for the site.',
    'We identified multiple purchase points within the experience, including specifically targeted upselling opportunities that delivered an amazing conversion rate of over 6%.',
  ],
  carousel: [
    {
      img: 'callout_1.jpg',
      title: 'IMMERSIVE ENVIRONMENT',
      content: ['PINBOARD FRONTEND ALLOWED USERS TO ENGAGE WITH THE THEMES THAT MOST INTERESTED THEM.'],
    },
    {
      img: 'callout_2.jpg',
      title: 'GOOGLE TECHNOLOGIES',
      content: ['INNOVATIVE USE OF GOOGLE MAPS AND STREET VIEW.'],
    },
    {
      img: 'callout_3.jpg',
      title: 'SOCIAL TOOL',
      content: ['‘JOIN THE ORDER’ SOCIAL TOOL ALLOWED USERS TO BECOME A KNIGHT AND SHARE THE IMAGE WITH FRIENDS.'],
    },
  ],
  nextCaseStudy: 'play-with-oreo',
};

export default casestudyData;
